<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getVenueHireTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionVenueHire && permissionVenueHire.permission_id === permission.readWrite"
          @click.native="createVenueHire" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
                <template v-if="header.icon">
                  <a @click="sortDataTable()">
                    <v-icon class="fas fa-caret-down"
                            v-if="sort == 'desc'"
                            style="font-size: 12px"></v-icon>
                    <v-icon class="fas fa-caret-up"
                            v-if="sort == 'asc'"
                            style="font-size: 12px"></v-icon>
                  </a>
                </template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>
                {{
                  item.branch
                    ? item.branch.branch_name_th + "(" + item.branch.branch_name_en + ")"
                    : ""
                }}
              </td>
              <td>{{ item.name_th }}</td>
              <td>{{ item.contact_email }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>
                <a @click="showVenueHireData(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import IconPencil from "../../../components/Icon/icon-pencil";
import InputTextField from "../../../components/Input/InputTextField";
import CircleButton from "../../../components/Button/CircleButton";
import InputSearch from "../../../components/Input/InputSearch";
import Paginate from "../../../components/Layout/Paginate";
import {permissionVenueHire, role} from "../../../util/Permission";
import {mapState} from "vuex";
import Swal from 'sweetalert';
import Loading from 'vue-loading-overlay';

export default {
  name: "VenueHireTable",
  components: {Paginate, InputSearch, CircleButton, InputTextField, IconPencil, Loading },
  data() {
    return {
      title: "Venue hire",
      isLoading: false,
      headers: [
        { id: 1, text: "No." ,icon : null},
        { id: 2, text: "Branch" ,icon : null},
        { id: 3, text: "Venue hire" ,icon : null},
        { id: 4, text: "Contact email" ,icon : null},
        { id: 5, text: "Update date" ,icon : true},
        { id: 6, text: "edit",icon : null }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      },
      permission : null,
      search : '',
      sort_date : 'desc',
      sort : 'desc',
    };
  },
  computed: {
    permissionVenueHire,
  },
  created() {
    this.permission = role;
    this.getVenueHireTable(1);
  },
  methods: {
    goToVenueHireEdit() {
      this.$router.push("/venue-hire/edit");
    },
    getVenueHireTable(page) {
      this.isLoading = true;
      this.$store.dispatch("VenueHire/getVenueHire", {
        page,
        search : this.search,
        sort_date : this.sort_date,
      }).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    async changePage(val){
      this.isLoading = true;
      this.dataPaginate.current_page = val;
      await this.getVenueHireTable(this.dataPaginate.current_page);
      this.isLoading = false;
    },
    createVenueHire() {
      this.$store.dispatch("VenueHire/clearFormData").then(() => {
        this.goToVenueHireEdit();
      });
    },
    showVenueHireData(id) {
      this.isLoading = true;
      this.$store.dispatch("VenueHire/showVenueHire", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("VenueHire/setFormVenueHire", res.result).then(() => {
            this.goToVenueHireEdit();
          });
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    searchInput(val){
      this.search = val;
    },
    sortDataTable(){
      this.sort = this.sort == 'desc' ? 'asc' : 'desc';
      this.sort_date = this.sort_date == 'desc' ? 'asc' : 'desc';
      this.getVenueHireTable(1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/table.css";
@import "../../../assets/css/variables";
.branch-data {
  background-color: $background-theme;
  margin: 20px;
}
</style>
